import { useEffect, useState } from 'react';
import './App.css';

const EXPERIENCE_STATS = [
  { label: 'Taxi Units', value: 100 },
  { label: 'Years Experience', value: 87, isFeatured: true },
  { label: 'Happy Clients', value: 100 },
  { label: 'Membership', value: 100 },
];

const AIRPORTS = [
  {
    name: 'Heathrow Airport (LHR)',
    desc: 'Taxi 247 Cabs provides reliable and comfortable transfer services to and from Heathrow Airport, ensuring a smooth and stress-free journey. Taxi 247 Cabs focuses on punctual pickups, professional drivers, and well-maintained vehicles for a premium travel experience. Whether traveling for business or leisure, Taxi 247 Cabs guarantees dependable airport transportation.',
  },
  {
    name: 'Gatwick Airport (LGW)',
    desc: 'Taxi 247 Cabs offers efficient and timely taxi services to and from Gatwick Airport, making travel simple and convenient. Taxi 247 Cabs ensures safe journeys with experienced drivers and comfortable vehicles. Passengers can rely on Taxi 247 Cabs for hassle-free airport transfers every time.',
  },
  {
    name: 'Manchester Airport (MAN)',
    desc: 'Taxi 247 Cabs provides professional airport transfer services to Manchester Airport with a focus on comfort and reliability. Taxi 247 Cabs ensures on-time pickups and smooth travel for all passengers. Enjoy a relaxed journey with Taxi 247 Cabs.',
  },
  {
    name: 'Stansted Airport (STN)',
    desc: 'Taxi 247 Cabs delivers dependable transfer services to Stansted Airport, ensuring timely and stress-free travel. Taxi 247 Cabs uses experienced drivers and modern vehicles for a comfortable ride. Travel confidently with Taxi 247 Cabs.',
  },
  {
    name: 'Luton Airport (LTN)',
    desc: 'Taxi 247 Cabs offers convenient taxi services to and from Luton Airport with a strong focus on punctuality. Taxi 247 Cabs ensures a safe and comfortable journey for every passenger. Choose Taxi 247 Cabs for reliable airport transfers.',
  },
  {
    name: 'Birmingham Airport (BHX)',
    desc: 'Taxi 247 Cabs provides smooth and efficient transfers to Birmingham Airport, ensuring a comfortable travel experience. Taxi 247 Cabs focuses on timely service and customer satisfaction. Passengers can trust Taxi 247 Cabs for dependable journeys.',
  },
  {
    name: 'Edinburgh Airport (EDI)',
    desc: 'Taxi 247 Cabs offers reliable airport transfers to Edinburgh Airport with a focus on comfort and punctuality. Taxi 247 Cabs ensures smooth pickups and drop-offs for all travelers. Enjoy stress-free travel with Taxi 247 Cabs.',
  },
  {
    name: 'Glasgow Airport (GLA)',
    desc: 'Taxi 247 Cabs provides professional transfer services to Glasgow Airport, ensuring safe and timely journeys. Taxi 247 Cabs delivers comfort and reliability with experienced drivers. Travel easily with Taxi 247 Cabs.',
  },
  {
    name: 'Bristol Airport (BRS)',
    desc: 'Taxi 247 Cabs offers dependable taxi services to Bristol Airport, making airport travel simple and convenient. Taxi 247 Cabs ensures a comfortable and smooth journey. Choose Taxi 247 Cabs for reliable transfers.',
  },
  {
    name: 'Newcastle Airport (NCL)',
    desc: 'Taxi 247 Cabs provides efficient transfer services to Newcastle Airport, ensuring a stress-free travel experience. Taxi 247 Cabs focuses on safety, comfort, and punctuality. Passengers can rely on Taxi 247 Cabs every time.',
  },
  {
    name: 'Liverpool John Lennon Airport (LPL)',
    desc: 'Taxi 247 Cabs offers reliable airport transfers to Liverpool John Lennon Airport with a focus on comfort and convenience. Taxi 247 Cabs ensures smooth and timely travel. Enjoy hassle-free journeys with Taxi 247 Cabs.',
  },
  {
    name: 'East Midlands Airport (EMA)',
    desc: 'Taxi 247 Cabs provides professional taxi services to East Midlands Airport, ensuring safe and timely transportation. Taxi 247 Cabs focuses on delivering a smooth and comfortable experience. Travel with confidence using Taxi 247 Cabs.',
  },
  {
    name: 'Aberdeen Airport (ABZ)',
    desc: 'Taxi 247 Cabs offers long-distance airport transfer services to Aberdeen Airport with comfort and reliability. Taxi 247 Cabs ensures a safe and relaxing journey for all passengers. Trust Taxi 247 Cabs for dependable travel.',
  },
  {
    name: 'Belfast International Airport (BFS)',
    desc: 'Taxi 247 Cabs provides efficient and reliable transfers to Belfast International Airport, ensuring a smooth travel experience. Taxi 247 Cabs focuses on punctual service and passenger comfort. Choose Taxi 247 Cabs for stress-free journeys.',
  },
  {
    name: 'London City Airport (LCY)',
    desc: 'Taxi 247 Cabs offers convenient taxi services to London City Airport with a focus on speed and reliability. Taxi 247 Cabs ensures timely pickups and comfortable rides. Travel easily with Taxi 247 Cabs.',
  },
];

const SERVICES = [
  {
    title: 'Airport Transfers',
    img: 'Airport Transfers.jpg',
    desc: 'Taxi 247 Cabs provides reliable and on-time airport transfer services in Edinburgh, ensuring passengers reach their destination without any stress or delay. Taxi 247 Cabs focuses on comfort, punctuality, and a smooth travel experience for both arrivals and departures. With professional drivers, well-maintained vehicles, and real-time flight tracking, Taxi 247 Cabs makes airport journeys easy, safe, and dependable for every traveler.',
  },
  {
    title: 'Free Child & Baby Seats',
    img: 'Free Child & Baby Seats.jpg',
    desc: 'Taxi 247 Cabs offers free child and baby seat facilities in Edinburgh to ensure safe and secure travel for families with young children. Taxi 247 Cabs prioritizes passenger safety by providing properly fitted seats for infants and kids of all ages. Families can enjoy comfortable and worry-free journeys knowing Taxi 247 Cabs takes extra care of their safety needs.',
  },
  {
    title: 'Meet & Greet Service',
    img: 'Meet & Greet Service.jpg',
    desc: 'Taxi 247 Cabs provides a professional meet & greet service at Edinburgh airport where drivers warmly welcome passengers upon arrival. Taxi 247 Cabs assists with luggage handling and guides passengers smoothly to their vehicles without any confusion. This service ensures a stress-free, friendly, and welcoming airport experience with Taxi 247 Cabs.',
  },
  {
    title: '24/7 Taxi Service',
    img: '247 Taxi Service.jfif',
    desc: 'Taxi 247 Cabs operates a 24/7 taxi service in Edinburgh, allowing passengers to book rides at any time of the day or night. Taxi 247 Cabs ensures that transportation is always available, whether it\'s early morning or late night travel. With round-the-clock service and quick response times, Taxi 247 Cabs provides maximum convenience and reliability.',
  },
  {
    title: 'Executive & Business Travel',
    img: 'Executive & Business Travel.webp',
    desc: 'Taxi 247 Cabs offers premium executive and business travel services in Edinburgh designed for corporate clients and professionals. Taxi 247 Cabs ensures privacy, comfort, and high-quality service for meetings, conferences, and official trips. Business travelers rely on Taxi 247 Cabs for punctual, smooth, and professional travel experiences every time.',
  },
  {
    title: 'City-to-City Transfers',
    img: 'City-to-City Transfers.jpg',
    desc: 'Taxi 247 Cabs provides reliable city-to-city transfer services from Edinburgh, making intercity travel simple, smooth, and comfortable. Taxi 247 Cabs ensures safe long-distance journeys with experienced drivers and well-maintained vehicles. Passengers can travel between cities with confidence, enjoying a relaxed and hassle-free ride.',
  },
  {
    title: 'Minibus & Group Travel',
    img: 'Minibus & Group Travel.jpg',
    desc: 'Taxi 247 Cabs offers spacious minibus and group travel services in Edinburgh, perfect for families, events, and group tours. Taxi 247 Cabs provides comfortable seating, extra space, and convenience for multiple passengers and luggage. Group travel becomes easy, organized, and enjoyable with Taxi 247 Cabs.',
  },
  {
    title: 'Wheelchair Accessible Vehicles',
    img: 'Wheelchair Accessible.webp',
    desc: 'Taxi 247 Cabs provides wheelchair accessible vehicles in Edinburgh to ensure inclusive and comfortable travel for all passengers. Taxi 247 Cabs is committed to supporting passengers with mobility needs through specially designed and equipped vehicles. Everyone can travel safely, comfortably, and independently with Taxi 247 Cabs.',
  },
  {
    title: 'Pet-Friendly Taxi Service',
    img: 'Pet-Friendly Service.jpg',
    desc: 'Taxi 247 Cabs offers pet-friendly taxi services in Edinburgh, allowing passengers to travel with their pets comfortably. Taxi 247 Cabs ensures a safe, clean, and relaxed environment for both passengers and their furry companions. Pet owners can travel easily without any worries using Taxi 247 Cabs.',
  },
  {
    title: 'Courier & Parcel Delivery',
    img: 'Courier & Parcel Delivery.webp',
    desc: 'Taxi 247 Cabs provides fast and secure courier and parcel delivery services in Edinburgh for both personal and business needs. Taxi 247 Cabs ensures safe handling and timely delivery of packages across the city. Customers trust Taxi 247 Cabs for quick, reliable, and efficient delivery solutions.',
  },
  {
    title: 'Long Distance Journeys',
    img: 'Long Distance Journeys.webp',
    desc: 'Taxi 247 Cabs offers long-distance travel services from Edinburgh with comfort and safety as top priorities. Taxi 247 Cabs uses experienced drivers to ensure smooth and enjoyable journeys over long routes. Passengers can relax and enjoy stress-free travel with dependable service.',
  },
  {
    title: 'Easy Online Booking',
    img: 'Easy Online Booking.png',
    desc: 'Taxi 247 Cabs provides an easy online booking system in Edinburgh, making ride reservations quick and simple. Taxi 247 Cabs allows customers to book taxis within minutes through a user-friendly platform. Convenience, speed, and ease of use are the main focus of Taxi 247 Cabs.',
  },
  {
    title: 'Secure Online Payments',
    img: 'Secure Online Payments.jpg',
    desc: 'Taxi 247 Cabs supports secure online payment options in Edinburgh for safe and hassle-free transactions. Taxi 247 Cabs ensures all payments are protected with advanced security systems and encryption. Customers can pay easily and confidently without any concerns.',
  },
  {
    title: 'Extra Luggage Transfers',
    img: 'Extra Luggage Transfers.jpg',
    desc: 'Taxi 247 Cabs accommodates extra luggage in Edinburgh, making travel easier for passengers with heavy or additional baggage. Taxi 247 Cabs provides vehicles with sufficient space to handle all luggage needs comfortably. Passengers can travel stress-free without worrying about space.',
  },
  {
    title: 'Flight Monitoring & Delay Tracking',
    img: 'Flight Monitoring.jpg',
    desc: 'Taxi 247 Cabs offers real-time flight monitoring in Edinburgh to adjust pickup times according to delays or early arrivals. Taxi 247 Cabs ensures drivers are always updated with flight schedules for smooth coordination. This service guarantees a stress-free and perfectly timed airport pickup experience.',
  },
];

const getAirportSlug = (name) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const findAirportBySlug = (slug) =>
  AIRPORTS.find((airport) => getAirportSlug(airport.name) === slug);

const getServiceSlug = (title) =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const findServiceBySlug = (slug) =>
  SERVICES.find((svc) => getServiceSlug(svc.title) === slug);

function App() {
  const [experienceValues, setExperienceValues] = useState(
    EXPERIENCE_STATS.map(() => 0)
  );
  const [activeHash, setActiveHash] = useState(window.location.hash || '#home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isAirportDetailsPage = activeHash.startsWith('#/airport-details/');
  const selectedAirportSlug = activeHash.replace('#/airport-details/', '');
  const selectedAirport = findAirportBySlug(selectedAirportSlug);

  const isServiceDetailsPage = activeHash.startsWith('#/service-details/');
  const selectedServiceSlug = activeHash.replace('#/service-details/', '');
  const selectedService = findServiceBySlug(selectedServiceSlug);

  useEffect(() => {
    const durationMs = 1400;
    const steps = 45;
    let currentStep = 0;

    const timer = window.setInterval(() => {
      currentStep += 1;

      setExperienceValues(
        EXPERIENCE_STATS.map((stat) =>
          Math.min(stat.value, Math.round((stat.value * currentStep) / steps))
        )
      );

      if (currentStep >= steps) {
        window.clearInterval(timer);
      }
    }, durationMs / steps);

    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      setActiveHash(window.location.hash || '#home');
      setIsMenuOpen(false);
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (
      activeHash.startsWith('#/airport-details/') ||
      activeHash.startsWith('#/service-details/')
    ) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return undefined;
    }

    if (activeHash === '#airport' || activeHash === '#services') {
      const sectionId = activeHash.replace('#', '');
      const timer = window.setTimeout(() => {
        const section = document.getElementById(sectionId);

        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 0);

      return () => window.clearTimeout(timer);
    }

    return undefined;
  }, [activeHash]);

  const renderBrandLogo = (isFooter = false) => (
    <span className={`brand-logo-custom ${isFooter ? 'brand-logo-custom-footer' : ''}`} aria-hidden="true">
      <span className="brand-logo-mark">
        <svg viewBox="0 0 24 24">
          <path d="M3 12h18" />
          <path d="M5 12 6.5 7.8A2.5 2.5 0 0 1 8.85 6h6.3a2.5 2.5 0 0 1 2.35 1.8L19 12" />
          <rect x="4" y="12" width="16" height="6" rx="2" />
          <circle cx="7.5" cy="15" r="1" />
          <circle cx="16.5" cy="15" r="1" />
        </svg>
      </span>
      <span className="brand-logo-copy">
        <strong>TAXI <span>247</span></strong>
        <small>PREMIUM TRANSFERS</small>
      </span>
    </span>
  );

  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/logo2.png)`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };

  const quickActions = [
    {
      label: 'Call Now',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 9h6v6H9z" opacity="0" />
          <path d="M9 2h6" />
          <path d="M3 2h6v6H3z" opacity="0" />
          <rect x="3.5" y="3.5" width="13" height="13" rx="1.5" />
          <path d="m7.5 10.2 2.1 2.1 3.9-4.2" />
        </svg>
      ),
      className: 'action-call',
      href: 'tel:02038393300',
    },
    {
      label: 'Get Quotation',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3.5" y="3.5" width="13" height="13" rx="1.5" />
          <path d="M9.7 6.8h3.6" />
          <path d="M11.5 6.8v6.4" />
          <path d="M9.2 9.6h3.8" />
          <path d="M8.7 12.6h5.7" />
        </svg>
      ),
      className: 'action-quote',
      href: 'https://booktaxinow.co.uk/',
      external: true,
    },
    {
      label: 'Book Now',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 12h18" />
          <path d="M5 12 6.5 7.8A2.5 2.5 0 0 1 8.85 6h6.3a2.5 2.5 0 0 1 2.35 1.8L19 12" />
          <rect x="4" y="12" width="16" height="6" rx="2" />
          <circle cx="7.5" cy="15" r="1" />
          <circle cx="16.5" cy="15" r="1" />
        </svg>
      ),
      className: 'action-book',
      href: 'https://booktaxinow.co.uk/',
      external: true,
    },
    {
      label: 'Airport Booking',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3.5" y="3.5" width="13" height="13" rx="1.5" />
          <path d="M12 2.7v3" />
          <path d="M8 2.7v3" />
          <path d="M3.5 8.2h13" />
          <path d="m7.1 11.3 1.7 1.8 3.6-3.7" />
        </svg>
      ),
      className: 'action-airport',
      href: 'https://booktaxinow.co.uk/',
      external: true,
    },
  ];

  const renderExperienceBand = (keySuffix) => (
    <section className="experience-band" aria-label="Taxi 247 experience highlights" key={keySuffix}>
      <div className="container">
        <p className="experience-label">Experience</p>
        <h2 className="experience-title">We are experienced since</h2>
        <div className="experience-grid" role="list">
          {EXPERIENCE_STATS.map((stat, index) => (
            <article
              className={`experience-card ${stat.isFeatured ? 'experience-card-featured' : ''}`}
              key={stat.label}
              role="listitem"
            >
              <p className="experience-number">{experienceValues[index]}</p>
              <p className="experience-card-label">{stat.label}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );

  const renderMobileCallStrip = () => (
    <a className="mobile-call-strip" href="tel:02038393300" aria-label="Call 02038393300">
      <span className="mobile-call-strip-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
        </svg>
      </span>
      <span>Call Now 02038393300</span>
    </a>
  );

  if (isServiceDetailsPage) {
    return (
      <div className="site-shell airport-details-page">
        <div className="top-bar">
          <div className="container top-bar-content">
            <p className="top-bar-info">Licensed & insured taxi service | 24/7 support</p>
            <p className="top-bar-contact">info@taxi247cabs.co.uk | 02038393300</p>
          </div>
        </div>

        <header className="site-header">
          <div className="container header-content">
            <a className="brand" href="#home" aria-label="Taxi 247 home">
              {renderBrandLogo()}
            </a>
            <button
              className="menu-toggle"
              type="button"
              onClick={() => setIsMenuOpen((prev) => !prev)}
              aria-expanded={isMenuOpen}
              aria-label="Toggle menu"
            >
              ☰
            </button>
            <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`} aria-label="Main navigation">
              <a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a>
              <a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a>
              <a href="#services" onClick={() => setIsMenuOpen(false)}>Our Services</a>
              <a href="#airport" onClick={() => setIsMenuOpen(false)}>Airport Transfers</a>
              <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
            </nav>
            <a className="header-contact-link" href="#contact">Contact Us</a>
          </div>
        </header>

        <main className="airport-details-main">
          <section className="hero airport-details-home-hero" style={heroStyle}>
            <div className="hero-overlay" />
            <div className="container hero-content">
              <div className="hero-intro">
                <p className="hero-kicker">Trusted 24/7 Transport Service</p>
                <h1 className="hero-title">
                  {selectedService ? selectedService.title : 'Our Services'}
                </h1>
                <p className="hero-subtitle">With Taxi 247 Cabs, available 24/7.</p>
              </div>
              <div className="quick-actions" role="list">
                {quickActions.map((action) => (
                  <a
                    className={`action-card ${action.className}`}
                    href={action.href}
                    key={action.label}
                    role="listitem"
                    target={action.external ? '_blank' : undefined}
                    rel={action.external ? 'noopener noreferrer' : undefined}
                  >
                    <span className="action-icon">{action.icon}</span>
                    <span className="action-text">{action.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </section>

          <section className="content-section">
            <div className="container">
              <p className="section-tag">Our Services</p>
              <h1 className="airport-details-title">
                {selectedService ? selectedService.title : 'Service Not Found'}
              </h1>
              <a className="airport-back-btn" href="#services">Back To Services</a>
              <div className="svc-details-layout">
                {selectedService ? (
                  <>
                    <div className="svc-details-img-wrap">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/${encodeURIComponent(selectedService.img)}`}
                        alt={selectedService.title}
                        className="svc-details-img"
                      />
                    </div>
                    <div className="svc-details-body">
                      <p>{selectedService.desc}</p>
                    </div>
                  </>
                ) : (
                  <p>The selected service could not be found. Please return to Our Services and choose again.</p>
                )}
              </div>
            </div>
          </section>

          <section className="content-section contact" id="contact">
            <div className="container">
              <p className="section-tag">Contact Us</p>
              <h2>Need help booking this service?</h2>
              <div className="contact-panel">
                <div className="contact-primary">
                  <div className="contact-call-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                    </svg>
                  </div>
                  <div className="contact-main-copy">
                    <p className="contact-support-line">We are open 24 hours throughout the year.</p>
                    <a className="contact-phone-link" href="tel:02038393300">Call us anytime at 02038393300</a>
                    <p className="contact-note">Fast support for instant booking and custom quotes.</p>
                  </div>
                </div>
                <div className="contact-methods">
                  <article className="contact-method-card">
                    <span className="contact-method-label">Call</span>
                    <a href="tel:02038393300">02038393300</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">Email</span>
                    <a href="mailto:info@taxi247cabs.co.uk">info@taxi247cabs.co.uk</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">WhatsApp</span>
                    <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">07365874733</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">Address</span>
                    <p>UK</p>
                  </article>
                </div>
              </div>
            </div>
          </section>
        </main>

        {renderMobileCallStrip()}

        <div className="floating-contact" aria-label="Quick contact actions">
          <a className="floating-btn floating-whatsapp" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
            </svg>
          </a>
          <a className="floating-btn floating-call" href="tel:+442038393300" aria-label="Call now">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
            </svg>
          </a>
        </div>

        <footer className="site-footer">
          <div className="container footer-grid">
            <div className="footer-brand-block">
              <a className="brand footer-brand-link" href="#home" aria-label="Taxi 247 home">
                {renderBrandLogo(true)}
              </a>
              <p>Professional taxi and airport transfer service focused on safety, punctuality, and comfort.</p>
            </div>
            <div className="footer-link-group">
              <h4>Quick Links</h4>
              <a href="#home">Home</a>
              <a href="#about">About Us</a>
              <a href="#services">Our Services</a>
              <a href="#airport">Airport Transfers</a>
            </div>
            <div className="footer-link-group">
              <h4>Contact</h4>
              <a className="footer-contact-item" href="mailto:info@taxi247cabs.co.uk">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24"><path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" /></svg>
                </span>
                <span>info@taxi247cabs.co.uk</span>
              </a>
              <a className="footer-contact-item" href="tel:02038393300">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24"><path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" /></svg>
                </span>
                <span>02038393300</span>
              </a>
              <a className="footer-contact-item" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24"><path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" /></svg>
                </span>
                <span>07365874733</span>
              </a>
            </div>
          </div>
          <p className="copyright">© {new Date().getFullYear()} <span className="copyright-brand">Taxi 247</span>. All rights reserved.</p>
        </footer>
      </div>
    );
  }

  if (isAirportDetailsPage) {
    return (
      <div className="site-shell airport-details-page">
        <div className="top-bar">
          <div className="container top-bar-content">
            <p className="top-bar-info">Licensed & insured taxi service | 24/7 support</p>
            <p className="top-bar-contact">info@taxi247cabs.co.uk | 02038393300</p>
          </div>
        </div>

        <header className="site-header">
          <div className="container header-content">
            <a className="brand" href="#home" aria-label="Taxi 247 home">
              {renderBrandLogo()}
            </a>
            <button
              className="menu-toggle"
              type="button"
              onClick={() => setIsMenuOpen((prev) => !prev)}
              aria-expanded={isMenuOpen}
              aria-label="Toggle menu"
            >
              ☰
            </button>
            <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`} aria-label="Main navigation">
              <a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a>
              <a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a>
              <a href="#services" onClick={() => setIsMenuOpen(false)}>Our Services</a>
              <a href="#airport" onClick={() => setIsMenuOpen(false)}>Airport Transfers</a>
              <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
            </nav>
            <a className="header-contact-link" href="#contact">Contact Us</a>
          </div>
        </header>

        <main className="airport-details-main">
          <section
            className="hero airport-details-home-hero"
            style={heroStyle}
          >
            <div className="hero-overlay" />
            <div className="container hero-content">
              <div className="hero-intro">
                <p className="hero-kicker">Trusted 24/7 Transport Service</p>
                <h1 className="hero-title">
                  {selectedAirport
                    ? selectedAirport.name
                    : 'Reliable airport transfers and city rides'}
                </h1>
                <p className="hero-subtitle">With Taxi 247 Cabs, available 24/7.</p>
              </div>
              <div className="quick-actions" role="list">
                {quickActions.map((action) => (
                  <a
                    className={`action-card ${action.className}`}
                    href={action.href}
                    key={action.label}
                    role="listitem"
                    target={action.external ? '_blank' : undefined}
                    rel={action.external ? 'noopener noreferrer' : undefined}
                  >
                    <span className="action-icon">{action.icon}</span>
                    <span className="action-text">{action.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </section>

          <section className="content-section">
            <div className="container">
              <p className="section-tag">Airport Transfers</p>
              <h1 className="airport-details-title">
                {selectedAirport ? selectedAirport.name : 'Airport Not Found'}
              </h1>
              <a className="airport-back-btn" href="#airport">Back To Airport List</a>
              <div className="airport-details-list">
                {selectedAirport ? (
                  <article className="airport-details-item" key={selectedAirport.name}>
                    <h2>{selectedAirport.name}</h2>
                    <p>{selectedAirport.desc}</p>
                  </article>
                ) : (
                  <article className="airport-details-item">
                    <h2>Details unavailable</h2>
                    <p>
                      The selected airport could not be found. Please return to
                      the airport transfers section and choose an airport again.
                    </p>
                  </article>
                )}
              </div>
            </div>
          </section>

          <section className="content-section contact" id="contact">
            <div className="container">
              <p className="section-tag">Contact Us</p>
              <h2>Need airport booking assistance?</h2>
              <div className="contact-panel">
                <div className="contact-primary">
                  <div className="contact-call-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                    </svg>
                  </div>
                  <div className="contact-main-copy">
                    <p className="contact-support-line">We are open 24 hours throughout the year.</p>
                    <a className="contact-phone-link" href="tel:02038393300">Call us anytime at 02038393300</a>
                    <p className="contact-note">Fast support for instant booking and custom quotes.</p>
                  </div>
                </div>

                <div className="contact-methods">
                  <article className="contact-method-card">
                    <span className="contact-method-label">Call</span>
                    <a href="tel:02038393300">02038393300</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">Email</span>
                    <a href="mailto:info@taxi247cabs.co.uk">info@taxi247cabs.co.uk</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">WhatsApp</span>
                    <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">07365874733</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">Address</span>
                    <p>UK</p>
                  </article>
                </div>
              </div>
            </div>
          </section>
        </main>

        {renderMobileCallStrip()}

        <div className="floating-contact" aria-label="Quick contact actions">
          <a
            className="floating-btn floating-whatsapp"
            href="https://wa.me/447365874733"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
            </svg>
          </a>
          <a
            className="floating-btn floating-call"
            href="tel:+442038393300"
            aria-label="Call now"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
            </svg>
          </a>
        </div>

        <footer className="site-footer">
          <div className="container footer-grid">
            <div className="footer-brand-block">
              <a className="brand footer-brand-link" href="#home" aria-label="Taxi 247 home">
                {renderBrandLogo(true)}
              </a>
              <p>
                Professional taxi and airport transfer service focused on safety,
                punctuality, and comfort.
              </p>
            </div>
            <div className="footer-link-group">
              <h4>Quick Links</h4>
              <a href="#home">Home</a>
              <a href="#about">About Us</a>
              <a href="#services">Our Services</a>
              <a href="#airport">Airport Transfers</a>
            </div>
            <div className="footer-link-group">
              <h4>Contact</h4>
              <p className="footer-contact-item">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M12 2a7 7 0 0 0-7 7c0 4.96 7 13 7 13s7-8.04 7-13a7 7 0 0 0-7-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
                  </svg>
                </span>
                <span>UK</span>
              </p>
              <a className="footer-contact-item" href="mailto:info@taxi247cabs.co.uk">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" />
                  </svg>
                </span>
                <span>info@taxi247cabs.co.uk</span>
              </a>
              <a className="footer-contact-item" href="tel:02038393300">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                  </svg>
                </span>
                <span>02038393300</span>
              </a>
              <a className="footer-contact-item" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
                  </svg>
                </span>
                <span>07365874733</span>
              </a>
            </div>
          </div>
          <p className="copyright">
            © {new Date().getFullYear()} <span className="copyright-brand">Taxi 247</span>. All rights reserved.
          </p>
        </footer>
      </div>
    );
  }

  return (
    <div className="site-shell">
      <div className="top-bar">
        <div className="container top-bar-content">
          <p className="top-bar-info">Licensed & insured taxi service | 24/7 support</p>
          <p className="top-bar-contact">info@taxi247cabs.co.uk | 02038393300</p>
        </div>
      </div>

      <header className="site-header">
        <div className="container header-content">
          <a className="brand" href="#home" aria-label="Taxi 247 home">
            {renderBrandLogo()}
          </a>

          <button
            className="menu-toggle"
            type="button"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-expanded={isMenuOpen}
            aria-label="Toggle menu"
          >
            ☰
          </button>

          <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`} aria-label="Main navigation">
            <a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a>
            <a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a>
            <a href="#services" onClick={() => setIsMenuOpen(false)}>Our Services</a>
            <a href="#airport" onClick={() => setIsMenuOpen(false)}>Airport Transfers</a>
            <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
          </nav>

          <a className="header-contact-link" href="#contact">Contact Us</a>
        </div>
      </header>

      <main>
        <section className="hero" id="home" style={heroStyle}>
          <div className="hero-overlay" />
          <div className="container hero-content">
            <div className="hero-intro">
              <p className="hero-kicker">Trusted 24/7 Transport Service</p>
              <h1 className="hero-title">Reliable airport transfers and city rides</h1>
              <p className="hero-subtitle">With Taxi 247 Cabs, available 24/7.</p>
            </div>
            <div className="quick-actions" role="list">
              {quickActions.map((action) => (
                <a
                  className={`action-card ${action.className}`}
                  href={action.href}
                  key={action.label}
                  role="listitem"
                  target={action.external ? '_blank' : undefined}
                  rel={action.external ? 'noopener noreferrer' : undefined}
                >
                  <span className="action-icon">{action.icon}</span>
                  <span className="action-text">{action.label}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {renderExperienceBand('top')}

        <section className="content-section" id="about">
          <div className="container about-layout">
            <div className="about-main">
              <p className="section-tag">About Us</p>
              <h2>About Taxi 247</h2>
              <p className="about-intro">
                Taxi 247 is a trusted provider of minicab services, operating
                24/7 to meet diverse travel needs. With a strong commitment to
                safety and professionalism, our drivers are fully licensed and
                DBS-checked for complete passenger peace of mind.
              </p>
              <p>
                We offer a practical and affordable alternative to Black Cabs,
                with fares up to 35% lower without compromising on quality,
                comfort, or reliability.
              </p>

              <h3>What We Do</h3>
              <p>
                We provide comprehensive transport solutions including local
                trips, airport transfers, and wheelchair-accessible travel. Our
                fleet includes Saloon Cars, Executive Cars, MPVs, and 6 to
                8-seater minibuses to support all group sizes and requirements.
              </p>

              <h3>What We Offer</h3>
              <ul className="about-offer-list">
                <li>24/7 service available day and night</li>
                <li>Fully licensed and DBS-checked drivers</li>
                <li>Wheelchair-accessible vehicle options</li>
                <li>Airport transfers for Heathrow, Gatwick, Stansted, Luton, and London City Airport</li>
                <li>Fast booking via web or call on 02038393300</li>
              </ul>
            </div>

            <div className="about-blocks">
              <article className="about-card">
                <h3>Our Mission</h3>
                <p>
                  To provide safe, reliable, and affordable transportation
                  services through skilled drivers, a modern fleet, and
                  customer-first support for stress-free daily and airport
                  journeys.
                </p>
              </article>
              <article className="about-card">
                <h3>Our Vision</h3>
                <p>
                  To be the most trusted and preferred Taxi 247 service,
                  recognized for safety, affordability, and customer
                  satisfaction while continuously improving booking and travel
                  experiences.
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className="content-section services" id="services">
          <div className="container">
            <p className="section-tag">Our Services</p>
            <h2>What We Offer</h2>
            <p className="services-sub">Professional transport solutions available 24/7 across Taxi 247 Cabs and beyond.</p>
            <div className="service-grid-pro">
              {[
                {
                  title: 'Airport Transfers',
                  desc: 'Taxi 247 Cabs provides reliable and on-time airport transfer services in Edinburgh, ensuring passengers reach their destination without any stress or delay. Taxi 247 Cabs focuses on comfort, punctuality, and smooth travel experience for both arrivals and departures. With professional drivers and well-maintained vehicles, Taxi 247 Cabs makes airport journeys easy and dependable.',
                  img: 'Airport Transfers.jpg',
                },
                {
                  title: 'Free Child & Baby Seats',
                  desc: 'Taxi 247 Cabs offers free child and baby seat facilities in Edinburgh to ensure safe and secure travel for families with young children. Taxi 247 Cabs prioritizes passenger safety by providing properly fitted seats for infants and kids. Families can enjoy comfortable journeys knowing Taxi 247 Cabs takes care of their safety needs.',
                  img: 'Free Child & Baby Seats.jpg',
                },
                {
                  title: 'Meet & Greet Service',
                  desc: 'Taxi 247 Cabs provides a professional meet & greet service at Edinburgh airport where drivers warmly welcome passengers upon arrival. Taxi 247 Cabs assists with luggage handling and guides passengers smoothly to their vehicles. This service ensures a stress-free and welcoming airport experience with Taxi 247 Cabs.',
                  img: 'Meet & Greet Service.jpg',
                },
                {
                  title: '24/7 Taxi Service',
                  desc: 'Taxi 247 Cabs operates a 24/7 taxi service in Edinburgh, allowing passengers to book rides at any time of the day or night. Taxi 247 Cabs ensures that transportation is always available, regardless of time or urgency. With round-the-clock service, Taxi 247 Cabs provides maximum convenience for all customers.',
                  img: '247 Taxi Service.jfif',
                },
                {
                  title: 'Executive & Business Travel',
                  desc: 'Taxi 247 Cabs offers premium executive and business travel services in Edinburgh designed for corporate clients and professionals. Taxi 247 Cabs ensures privacy, comfort, and high-quality service for meetings, conferences, and official trips. Business travelers rely on Taxi 247 Cabs for a smooth and professional travel experience.',
                  img: 'Executive & Business Travel.webp',
                },
                {
                  title: 'City-to-City Transfers',
                  desc: 'Taxi 247 Cabs provides reliable city-to-city transfer services from Edinburgh, making intercity travel simple and comfortable. Taxi 247 Cabs ensures safe long-distance journeys with experienced drivers and well-maintained vehicles. Passengers can travel between cities with confidence using Taxi 247 Cabs.',
                  img: 'City-to-City Transfers.jpg',
                },
                {
                  title: 'Minibus & Group Travel',
                  desc: 'Taxi 247 Cabs offers spacious minibus and group travel services in Edinburgh, perfect for families, events, and group tours. Taxi 247 Cabs provides comfortable seating and ample space for multiple passengers and luggage. Group travel becomes easy and enjoyable with Taxi 247 Cabs.',
                  img: 'Minibus & Group Travel.jpg',
                },
                {
                  title: 'Wheelchair Accessible Vehicles',
                  desc: 'Taxi 247 Cabs provides wheelchair accessible vehicles in Edinburgh to ensure inclusive and comfortable travel for all passengers. Taxi 247 Cabs is committed to supporting passengers with mobility needs through specially designed vehicles. Everyone can travel safely and independently with Taxi 247 Cabs.',
                  img: 'Wheelchair Accessible.webp',
                },
                {
                  title: 'Pet-Friendly Taxi Service',
                  desc: 'Taxi 247 Cabs offers pet-friendly taxi services in Edinburgh, allowing passengers to travel with their pets comfortably. Taxi 247 Cabs ensures a safe and relaxed environment for both passengers and their animals. Pet owners can travel without worry using Taxi 247 Cabs.',
                  img: 'Pet-Friendly Service.jpg',
                },
                {
                  title: 'Courier & Parcel Delivery',
                  desc: 'Taxi 247 Cabs provides fast and secure courier and parcel delivery services in Edinburgh for both personal and business needs. Taxi 247 Cabs ensures safe handling and timely delivery of packages across the city. Customers trust Taxi 247 Cabs for reliable delivery solutions.',
                  img: 'Courier & Parcel Delivery.webp',
                },
                {
                  title: 'Long Distance Journeys',
                  desc: 'Taxi 247 Cabs offers long-distance travel services from Edinburgh with comfort and safety as top priorities. Taxi 247 Cabs uses experienced drivers to ensure smooth journeys over long routes. Passengers can relax and enjoy stress-free travel with Taxi 247 Cabs.',
                  img: 'Long Distance Journeys.webp',
                },
                {
                  title: 'Easy Online Booking',
                  desc: 'Taxi 247 Cabs provides an easy online booking system in Edinburgh, making ride reservations quick and simple. Taxi 247 Cabs allows customers to book taxis within minutes through a user-friendly platform. Convenience and efficiency are the main focus of Taxi 247 Cabs.',
                  img: 'Easy Online Booking.png',
                },
                {
                  title: 'Secure Online Payments',
                  desc: 'Taxi 247 Cabs supports secure online payment options in Edinburgh for safe and hassle-free transactions. Taxi 247 Cabs ensures all payments are protected with advanced security systems. Customers can pay confidently using Taxi 247 Cabs.',
                  img: 'Secure Online Payments.jpg',
                },
                {
                  title: 'Extra Luggage Transfers',
                  desc: 'Taxi 247 Cabs accommodates extra luggage in Edinburgh, making travel easier for passengers with heavy or additional baggage. Taxi 247 Cabs provides vehicles with sufficient space for all luggage needs. Passengers can travel comfortably without luggage concerns using Taxi 247 Cabs.',
                  img: 'Extra Luggage Transfers.jpg',
                },
                {
                  title: 'Flight Monitoring & Delay Tracking',
                  desc: 'Taxi 247 Cabs offers real-time flight monitoring in Edinburgh to adjust pickup times according to delays or early arrivals. Taxi 247 Cabs ensures drivers are always updated with flight schedules for smooth coordination. This service guarantees a stress-free airport pickup experience with Taxi 247 Cabs.',
                  img: 'Flight Monitoring.jpg',
                },
              ].map((svc) => (
                <article className="svc-card" key={svc.title}>
                  <div className="svc-img-slot">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/${encodeURIComponent(svc.img)}`}
                      alt={svc.title}
                      className="svc-img"
                    />
                  </div>
                  <div className="svc-body">
                    <h3>{svc.title}</h3>
                    <p>{svc.desc}</p>
                    <a
                      className="airport-read-more"
                      href={`#/service-details/${getServiceSlug(svc.title)}`}
                    >
                      {svc.title}
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="content-section airport-section" id="airport">
          <div className="container">
            <p className="section-tag">Airport Transfers</p>
            <h2>Reliable Airport Transfers</h2>

            <div className="airport-hero">
              <div className="airport-hero-image-wrap">
                <img
                  src={`${process.env.PUBLIC_URL}/images/Airport%20Transfersslider.jpg`}
                  alt="Taxi 247 airport transfer service"
                  className="airport-hero-image"
                />
              </div>
              <div className="airport-hero-content">
                <p>
                  Taxi 247 Cabs provides reliable and professional airport
                  transfer services in Edinburgh, ensuring a smooth and
                  stress-free journey for every passenger. Taxi 247 Cabs focuses
                  on punctuality, offering on-time pickups and drop-offs so you
                  never have to worry about missing a flight. With experienced
                  drivers and comfortable vehicles, Taxi 247 Cabs guarantees a
                  safe and relaxing travel experience.
                </p>
                <p>
                  Whether you are traveling for business or leisure, Taxi 247
                  Cabs makes airport transportation simple, convenient, and
                  dependable. Additionally, Taxi 247 Cabs monitors flight
                  schedules to adjust pickup times according to delays or early
                  arrivals, ensuring maximum convenience for customers.
                </p>
                <a href="#contact" className="airport-cta">Reserve Airport Ride</a>
              </div>
            </div>

            <div className="airport-list-grid">
              {AIRPORTS.map((airport) => (
                <article className="airport-item" key={airport.name}>
                  <h3>{airport.name}</h3>
                  <p>{airport.desc}</p>
                  <a
                    className="airport-read-more"
                    href={`#/airport-details/${getAirportSlug(airport.name)}`}
                  >
                    Read More
                  </a>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="content-section contact" id="contact">
          <div className="container">
            <p className="section-tag">Contact Us</p>
            <h2>Have a question or need a custom quote?</h2>
            <div className="contact-panel">
              <div className="contact-primary">
                <div className="contact-call-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                  </svg>
                </div>
                <div className="contact-main-copy">
                  <p className="contact-support-line">We are open 24 hours throughout the year.</p>
                  <a className="contact-phone-link" href="tel:02038393300">Call us anytime at 02038393300</a>
                  <p className="contact-note">Fast support for instant booking and custom quotes.</p>
                </div>
              </div>

              <div className="contact-methods">
                <article className="contact-method-card">
                  <span className="contact-method-label">Call</span>
                  <a href="tel:02038393300">02038393300</a>
                </article>
                <article className="contact-method-card">
                  <span className="contact-method-label">Email</span>
                  <a href="mailto:info@taxi247cabs.co.uk">info@taxi247cabs.co.uk</a>
                </article>
                <article className="contact-method-card">
                  <span className="contact-method-label">WhatsApp</span>
                  <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">07365874733</a>
                </article>
                <article className="contact-method-card">
                  <span className="contact-method-label">Address</span>
                  <p>UK</p>
                </article>
              </div>
            </div>
          </div>
        </section>
      </main>

      {renderMobileCallStrip()}

      <div className="floating-contact" aria-label="Quick contact actions">
        <a
          className="floating-btn floating-whatsapp"
          href="https://wa.me/447365874733"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
          </svg>
        </a>
        <a
          className="floating-btn floating-call"
          href="tel:+442038393300"
          aria-label="Call now"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
          </svg>
        </a>
      </div>

      <footer className="site-footer">
        <div className="container footer-grid">
          <div className="footer-brand-block">
            <a className="brand footer-brand-link" href="#home" aria-label="Taxi 247 home">
              {renderBrandLogo(true)}
            </a>
            <p>
              Professional taxi and airport transfer service focused on safety,
              punctuality, and comfort.
            </p>
          </div>
          <div className="footer-link-group">
            <h4>Quick Links</h4>
            <a href="#home">Home</a>
            <a href="#about">About Us</a>
            <a href="#services">Our Services</a>
            <a href="#airport">Airport Transfers</a>
          </div>
          <div className="footer-link-group">
            <h4>Contact</h4>
            <p className="footer-contact-item">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2a7 7 0 0 0-7 7c0 4.96 7 13 7 13s7-8.04 7-13a7 7 0 0 0-7-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
                </svg>
              </span>
              <span>UK</span>
            </p>
            <a className="footer-contact-item" href="mailto:info@taxi247cabs.co.uk">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" />
                </svg>
              </span>
              <span>info@taxi247cabs.co.uk</span>
            </a>
            <a className="footer-contact-item" href="tel:02038393300">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                </svg>
              </span>
              <span>02038393300</span>
            </a>
            <a className="footer-contact-item" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
                </svg>
              </span>
              <span>07365874733</span>
            </a>
          </div>
        </div>
        <p className="copyright">
          © {new Date().getFullYear()} <span className="copyright-brand">Taxi 247</span>. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default App;
